import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import * as Api from 'api';
import * as Actions from 'actions';
import { MapDetails } from '../';
import { Collapse } from 'react-bootstrap';

class RecentlyAddedMaps extends React.Component {
  // propTypes = {
  //   maps: PropTypes.array
  // }
  state = {
    maps: [],
    offset : 0,
    loading: true,
    open: !localStorage? true : localStorage.getItem('recently-added-maps.open') == 'true',
  }
  constructor(props) {
    super(props)
    this.getMaps = this.getMaps.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.getMaps();
  }
  toggleOpen() {
    if(localStorage) {
      localStorage.setItem('recently-added-maps.open', !this.state.open ? 'true' : 'false');
    }
    this.setState({open: !this.state.open});
  }
  getMaps() {
    Api.fetchRecentMaps(25, this.state.offset)
    .then(maps =>
      this.setState({maps : [...this.state.maps, ...maps], loading: false})
    )
    .catch(error => {
      this.props.notify({message: error.message});
      this.setState({loading: false});
    });
  }
  render() {
    const {maps, loading} = this.state;
    if(!maps) {
      return <div></div>
    }

    return <div className="recently-added-maps mb-xl">
      <h3 className="text-dark"><i className="fa fa-map"></i> Latest Maps - <Link to={'/map/search'} className="btn btn-primary">Go To Maps</Link> <span onClick={this.toggleOpen} className="pull-right"><i className={`fa fa-chevron-${this.state.open ? 'down':'left'}`}></i></span></h3>
      <p className="text-muted">Select maps below then click the "Go to Maps" button to see them.</p>
      <Collapse in={this.state.open}>
        <div className="maps-container">
          {maps.map(map => <div className="map"><MapDetails map={map} /></div>)}
          <div className="map">{loading ? <div className="text-center text-primary"><i className="fa fa-spinner fa-spin fa-2x"></i></div> : <a onClick={e => {
            e.preventDefault();
            this.setState({offset : this.state.offset + 1, loading: true}, f => this.getMaps());
          }} href="#" className="text-center btn btn-block btn-primary">Load More</a>}</div>
        </div>
      </Collapse>
    </div>
  }
}

export const mapStateToProps = () => ({});

export default connect(mapStateToProps, Actions)(RecentlyAddedMaps);



// WEBPACK FOOTER //
// ./src/browser/components/dashboard/recently_added_maps.js